import {
  DirectLine,
  DirectLineOptions,
  Services,
} from 'botframework-directlinejs';
import { IAdsCopilotDirectLine } from '@bingads-webui/ads-copilot-shared-types';

type AdsCopilotDirectLineOptions = DirectLineOptions & Partial<Services> & {
  isCustomStream?: boolean;
  userId?: string;
  username?: string;
};

export class AdsCopilotDirectLine extends DirectLine implements IAdsCopilotDirectLine {
  public userId?: string;

  public username?: string;

  public existingToken?: string;

  public isCustomStream: boolean;

  constructor(args: AdsCopilotDirectLineOptions) {
    super(args);
    this.existingToken = args.token;

    this.isCustomStream = !!args.isCustomStream;
    this.userId = args.userId;
    this.username = args.username;
  }
}
